import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import TableComponent from "../TableComponent";

const FilledPage = (props) => {
  const dispatch = useDispatch();
  const pageInfo = useSelector(JobSelectors.getUpcomingFilledPaginationData)
  const jobListData = useSelector(JobSelectors.getListData({ timeframe: 'upcoming', status: 'filled', part: "data" }))
  const pageFilter = useSelector(JobSelectors.getListData({ timeframe: 'upcoming', status: 'filled', part: "filter" }))
  const pageSort = useSelector(JobSelectors.getListData({ timeframe: 'upcoming', status: 'filled', part: "sort" }))
  const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
    dispatch(JobActions.setUpcomingFilledPageSize(pageSize));
    dispatch(JobActions.setUpcomingFilledFilter(filters));
    dispatch(JobActions.setUpcomingFilledSort(sortBy));
    dispatch(JobActions.fetchUpcomingFilledJobs(pageIndex));
  }, []);

  return <TableComponent pageInfo={pageInfo} jobListData={jobListData} pageFilter={pageFilter} pageSort={pageSort} fetchData={fetchData} history={props.history} />
}

export default FilledPage